import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { blogIndexPath } from '../../data/blog/localePrefixes';
import './style.css';

const MobileNav = ({ navOpen, closeNav }) => {
  const { t, i18n } = useTranslation('common');
  const locale = i18n.language?.slice(0, 2) || 'en';

  const navItems = [
    { to: '/',                    key: 'home' },
    { to: '/prices',              key: 'prices' },
    { to: '/design',              key: 'design' },
    { to: '/projects',            key: 'projects' },
    { to: '/gallery',             key: 'gallery' },
    { to: blogIndexPath(locale),  key: 'blog' },
    { to: '/contacts',            key: 'contacts' },
  ];

  return (
    <div className={`mobile__nav ${navOpen ? 'open' : ''}`}>
      <button onClick={closeNav} className="close-btn">✕</button>
      <ul className="mobile__nav-links">
        {navItems.map(({ to, key }) => (
          <li key={key}>
            <NavLink to={to} onClick={closeNav}>{t(`nav.${key}`)}</NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MobileNav;
